import { useUnderlyingContext } from 'hooks/useUnderlyingContext';
import { useCallback, useContext } from 'react';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import { WorkspaceAnalyticCategoryContext } from 'shared/middlewares/analytics/loggerContext';
import styled from 'styled-components';

interface Props {
  underlyingId: string;
}

const StyledUnderlyingRemovingCell = styled.td`
  width: 1.5rem;
`;

export function Remove({ underlyingId }: Props) {
  const { onUnderlyingRemoved, isLoading } = useUnderlyingContext();
  const logAnalyticsCategory = useContext(WorkspaceAnalyticCategoryContext);
  const removeUnderlying = useCallback(() => {
    if (isLoading || typeof underlyingId === 'undefined' || typeof onUnderlyingRemoved !== 'function') {
      return;
    }
    logAnalytics.trackEvent(logAnalyticsCategory, 'Remove underlyings');
    onUnderlyingRemoved(underlyingId);
  }, [isLoading, onUnderlyingRemoved, underlyingId, logAnalyticsCategory]);

  return (
    <StyledUnderlyingRemovingCell className="align-middle text-center px-1">
      <button
        className="btn btn-icon"
        disabled={isLoading || underlyingId === undefined}
        onClick={removeUnderlying}
        type="button"
      >
        <i className="clickable icon text-secondary" data-e2e="selected-underlying-item-delete">
          delete
        </i>
      </button>
    </StyledUnderlyingRemovingCell>
  );
}
